<div class="sh-navigation">
    <div *ngIf="mainActionItem" class="sh-navigation__main-action">
        <sh-action-item [item]="mainActionItem"></sh-action-item>
    </div>
    <ul class="sh-navigation__list">
        <li class="sh-navigation__list__item" *ngFor="let item of primaryNavItems">
            <sh-navigation-item [item]="item"></sh-navigation-item>
        </li>
    </ul>
    <ul class="sh-navigation__list -sh-to-bottom" *ngIf="secondaryNavItems">
        <li class="sh-navigation__list__item" *ngFor="let item of secondaryNavItems">
            <sh-navigation-item [item]="item" [openDropmenuAbove]="true"></sh-navigation-item>
        </li>
    </ul>
</div>
